"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCandyMachineRuleSet = void 0;
const mpl_token_metadata_1 = require("@metaplex-foundation/mpl-token-metadata");
const umi_1 = require("@metaplex-foundation/umi");
const generated_1 = require("./generated");
const getCandyMachineRuleSet = async (context, candyMachine) => {
    const candyMachineAccount = await (0, generated_1.fetchCandyMachine)(context, candyMachine);
    if ((0, umi_1.isSome)(candyMachineAccount.ruleSet)) {
        return candyMachineAccount.ruleSet;
    }
    const collection = candyMachineAccount.collectionMint;
    const collectionAsset = await (0, mpl_token_metadata_1.fetchDigitalAsset)(context, collection);
    const { programmableConfig } = collectionAsset.metadata;
    if ((0, umi_1.isNone)(programmableConfig)) {
        return (0, umi_1.none)();
    }
    return programmableConfig.value.ruleSet;
};
exports.getCandyMachineRuleSet = getCandyMachineRuleSet;
//# sourceMappingURL=getCandyMachineRuleSet.js.map